import React, { Component } from 'react';
import { render, unmountComponentAtNode as remove } from 'react-dom';
import PropTypes from 'prop-types';

import AuthTimer from './auth-timer';
import Popup from '../popup';
import errorHandler from './service/errors';
import { setCookie, getCookie, monthTimeout } from '../../helpers/cookie';
import AuthInputs from './helpers/inputs';
import AuthActionBtn from './helpers/actionBtn';
import prepareAuthNotes from './helpers/notes';
import Checkbox from '../checkbox';

class Auth extends Component {
  static propTypes = {
    route: PropTypes.shape({
      login: PropTypes.string,
      verify: PropTypes.string,
      loginbypass: PropTypes.string,
    }).isRequired,
  };

  state = {
    loading: false,
    phone: '',
    password: '',
    tab: 'auth', // auth, reg, forget
    errorPhone: false,
    errorPassword: false,
    message: '',
    smsTimer: 0,
    type: 'sms', // sms, flashcall
    getCode: false,
    errorSmsAPI: false,
    agreementAccepted: false,
    personalDataAccepted: false,
  };

  // Берем телефон из куков
  componentDidMount() {
    const phone = getCookie('PHONE');

    if (phone) this.setState({ phone });

    if (window.location.href.includes('#registration')) {
      this.setState({
        tab: 'reg',
      });
    }
  }

  //  Попап с новым паролем
  newPass = () => {
    $.magnificPopup.open({
      items: {
        src: '#popup',
      },
      removalDelay: 250,
      callbacks: {
        beforeOpen() {
          this.st.mainClass = 'mfp-anim';
        },
        open() {
          render(<Popup type="new-pass" />, $('#popup')[0]);
        },
        close() {
          remove($('#popup')[0]);
          window.location.reload();
        },
      },
    });

    this.setState({
      loading: false,
    });
  };

  // Попап с ошибкой
  openPopup = message => {
    $.magnificPopup.open({
      items: {
        src: '#popup',
      },
      removalDelay: 250,
      callbacks: {
        beforeOpen() {
          this.st.mainClass = 'mfp-anim';
        },
        open() {
          render(
            <Popup
              type="alert"
              status="error"
              title="Ошибка!"
              message={message}
              button="Назад"
            />,
            $('#popup')[0],
          );
        },
        close() {
          remove($('#popup')[0]);
        },
      },
    });

    this.setState({ loading: false });
  };

  // Отправка формы
  confirm = e => {
    e.preventDefault();

    const { tab, errorPhone, getCode } = this.state;

    this.setState({ loading: true });

    switch (tab) {
      case 'auth':
        if (errorPhone) {
          this.setState({
            tab: 'reg',
            loading: false,
            errorPhone: false,
            password: '',
          });
          this.sendRequest('getCode');
        }
        if (!errorPhone) {
          this.sendRequest('confirmUser');
        }
        break;

      case 'reg':
        this.setState({ type: 'flashcall'})
        if (errorPhone)
          this.setState({
            tab: 'auth',
            loading: false,
            errorPhone: false,
            password: '',
          });
        if (!errorPhone && !getCode) this.sendRequest('getCode');
        if (!errorPhone && getCode) this.sendRequest('confirmCode');
        break;

      case 'forget':
        this.setState({ type: 'flashcall'})
        if (errorPhone) {
          this.setState({
            tab: 'reg',
            loading: false,
            errorPhone: false,
            getCode: true,
          });
          this.sendRequest('getCode');
        }
        if (!errorPhone && !getCode) this.sendRequest('getCode');
        if (!errorPhone && getCode) this.sendRequest('confirmCode');
        break;

      default:
        break;
    }
  };

  getErrors = err => {
    const responseError = errorHandler(err);

    // Проверка наличия кода ошибки в списке ошибок
    if (typeof responseError === 'undefined') {
      const message =
        typeof err.message !== 'undefined'
          ? err.message
          : 'Попробуйте обновить страницу.';
      this.openPopup(message);
    } else {
      this.setState(responseError);

      if (
        (typeof err.next_sms !== 'undefined' && err.next_sms > 60) ||
        err.code === 493
      ) {
        const txt = err.message.split('<a');
        const link = document.createElement('span');
        link.innerHTML = `<a${txt[1]}`;
        this.openPopup(txt[0]);
        document.querySelector('.popup__txt').appendChild(link);
      }
    }
  };

  sendRequest = typeRequest => {
    const { route } = this.props;
    const { phone, password, type } = this.state;

    const cleanPhone = phone
      ? phone.replace(/[/+()_-]*/g, '').replace(/\s/g, '')
      : '';

    const formData = new FormData();
    formData.append('phone', cleanPhone);
    formData.append('type', type);

    const headers = {
      method: 'POST',
      body: formData,
      headers: {},
      credentials: 'include',
    };

    const requestObj = {
      url: '',
    };

    switch (typeRequest) {
      case 'getCode':
        requestObj.url = route.login;
        break;

      case 'confirmCode':
        formData.append('code', password);
        requestObj.url = route.verify;
        break;

      case 'confirmUser':
        formData.append('password', password);
        requestObj.url = route.loginbypass;
        break;

      default:
        return false;
    }

    const success = resp => {
      switch (typeRequest) {
        case 'getCode':
          this.setState({
            loading: false,
            getCode: true,
            smsTimer: resp.next_sms,
            caption: resp.caption,
            type: resp.type,
          });
          break;

        case 'confirmCode':
          this.newPass();
          break;

        case 'confirmUser':
          setCookie('PHONE', cleanPhone, monthTimeout);
          if (!getCookie('userChooseInfo')) {
            document.location.href = resp.redirect_url;
          } else {
            window.location.href = JSON.parse(
              getCookie('userChooseInfo'),
            ).previousPage;
          }
          break;

        default:
          return false;
      }
    };

    fetch(requestObj.url, headers)
      .then(response => response.json())
      .then(json => {
        if (json.status === 'success') {
          json.data.user && setCookie('USER_ID', json.data.user.user_id)
          success(json.data);
        } else if (json.status === 'error') {
          this.getErrors(json.errors);
        }
      })
      .catch(() => {
        this.openPopup(
          'Попробуйте обновить страницу.',
        );
      });
  };

  prepareFormHead() {
    const { tab } = this.state;

    switch (tab) {
      case 'auth':
      case 'reg':
        return (
          <div className="login-form__tabs">
            <button
              type="button"
              className={tab == 'auth' ? 'tab tab--active' : 'tab'}
              onClick={() =>
                this.setState({
                  tab: 'auth',
                  password: '',
                  getCode: false,
                  type: 'sms',
                  errorPassword: false,
                  errorPhone: false,
                  agreementAccepted: false,
                  personalDataAccepted: false,
                })
              }
            >
              Вход
            </button>
            <button
              type="button"
              className={tab == 'reg' ? 'tab tab--active' : 'tab'}
              onClick={() =>
                this.setState({
                  tab: 'reg',
                  password: '',
                  getCode: false,
                  type: 'flashcall',
                  errorPassword: false,
                  errorPhone: false,
                  agreementAccepted: false,
                  personalDataAccepted: false,
                })
              }
            >
              Регистрация
            </button>
          </div>
        );

      case 'forget':
        return <h3 className="login-form__title">Забыли пароль?</h3>;

      default:
        return null;
    }
  }

  prepareFormFooter() {
    const { tab, errorPhone } = this.state;
    const forgetBtn = (
      <button
        type="button"
        className="login-form__note link accent"
        onClick={() =>
          this.setState({
            tab: 'forget',
            password: '',
            getCode: false,
            errorPassword: false,
            errorPhone: false,
            agreementAccepted: false,
            personalDataAccepted: false,
          })
        }
      >
        Забыли пароль?
      </button>
    );

    switch (tab) {
      case 'auth':
        if (!errorPhone) {
          return forgetBtn;
        }
        return null;

      case 'reg':
        if (errorPhone) {
          return forgetBtn;
        }
        return null;

      case 'forget':
        return (
          <div className="login-form__tabs login-form__tabs--forget">
            <button
              className="tab"
              type="button"
              onClick={() =>
                this.setState({
                  tab: 'auth',
                  password: '',
                  getCode: false,
                  errorPassword: false,
                  errorPhone: false,
                  agreementAccepted: false,
                  personalDataAccepted: false,
                })
              }
            >
              Вход
            </button>
            <button
              className="tab"
              type="button"
              onClick={() =>
                this.setState({
                  tab: 'reg',
                  password: '',
                  getCode: false,
                  errorPassword: false,
                  errorPhone: false,
                  agreementAccepted: false,
                  personalDataAccepted: false,
                })
              }
            >
              Регистрация
            </button>
          </div>
        );

      default:
        return null;
    }
  }

  minusTimer() {
    const { smsTimer } = this.state;
    if (smsTimer > 0) {
      this.setState({ smsTimer: smsTimer - 1 });
    }
  }

  prepareCheckboxes() {
    const { tab, agreementAccepted, personalDataAccepted } = this.state;

    if (tab !== 'auth' && tab !== 'reg') {
      return null;
    }

    return (
      <div className="login-form__checkboxes">
        <Checkbox
          key={`agreement-${tab}`}
          checked={agreementAccepted}
          value={agreementAccepted ? 1 : 0}
          name="agreement"
          label={
            <span>
              Согласен с{' '}
              <a href="/help/" target="_blank" className="link accent">
                пользовательским соглашением
              </a>
            </span>
          }
          onChange={(value) => {
            this.setState({ agreementAccepted: value === 1 });
          }}
          required
        />
        <Checkbox
          key={`personalData-${tab}`}
          checked={personalDataAccepted}
          value={personalDataAccepted ? 1 : 0}
          name="personalData"
          label={
            <span>
              Согласен с{' '}
              <a href="#" target="_blank" className="link accent">
                обработкой персональных данных
              </a>
            </span>
          }
          onChange={(value) => {
            this.setState({ personalDataAccepted: value === 1 });
          }}
          required
        />
      </div>
    );
  }

  prepareTimer() {
    const { getCode, tab, smsTimer, errorSmsAPI, caption } = this.state;
    switch (tab) {
      case 'auth':
        return null;

      case 'reg':
      case 'forget':
        if (getCode && !errorSmsAPI) {
          if (smsTimer > 0) {
            let count;
            let words;

            if (smsTimer > 60) {
              count = Math.ceil(smsTimer / 60);
              words = ['минуту', 'минуты', 'минут'];
            } else if (smsTimer <= 60) {
              count = smsTimer;
              words = ['секунду', 'секунды', 'секунд'];
            }

            return (
              <p className="login-form__note">
                {caption}
                <AuthTimer
                  count={count}
                  words={words}
                  callback={() => this.minusTimer()}
                />
              </p>
            );
          } else {
            return (
              <p className="login-form__note">
                <button
                  type="button"
                  className="login-form__note link accent"
                  onClick={() => {
                  this.setState({
                  type: 'flashcall',
                  });
                  this.sendRequest('getCode');
                  }}
                  >
                  Запросить еще звонок
                  </button>
                  <button
                  type="button"
                  className="login-form__note link accent"
                  onClick={() => {
                  this.setState({
                  type: 'sms',
                  });
                  this.sendRequest('getCode');
                  }}
                >
                  Получить код в смс
                </button>
              </p>
            );
          }
        }

      default:
        return null;
    }
  }

  changeState = vals => {
    this.setState({
      ...vals,
    });
  };

  render() {
    const {
      tab,
      phone,
      password,
      errorPhone,
      errorPassword,
      getCode,
      loading,
      message,
      type,
     } = this.state;
 let placeholder;
  
switch (type) {
case 'sms':
placeholder = 'Код из смс';

break;
case 'flashcall':
placeholder = 'Последние 4 цифры номера';

break;
default:
placeholder = 'Код из смс';

break;
}

    return (
      <form className="login-form" onSubmit={this.confirm}>
        {this.prepareFormHead()}
        <AuthInputs
          tab={tab}
          phone={phone}
          password={password}
          errorPhone={errorPhone}
          errorPassword={errorPassword}
          getCode={getCode}
          changeState={vals => this.changeState(vals)}
          placeholder={placeholder}
        />
        {prepareAuthNotes({ errorPassword, errorPhone, message })}
        {this.prepareCheckboxes()}
        <AuthActionBtn
          loading={loading}
          tab={tab}
          phone={phone}
          password={password}
          errorPhone={errorPhone}
          getCode={getCode}
          errorPassword={errorPassword}
          agreementAccepted={this.state.agreementAccepted}
          personalDataAccepted={this.state.personalDataAccepted}
        />
        {this.prepareTimer()}
        {this.prepareFormFooter()}
      </form>
    );
  }
}

export default Auth;
